
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.zh.md?watch=parent';
    export const toc = [{"id":"dropdown","depth":2,"title":"Dropdown"}];
export const frontmatter = {"title":"Dropdown","toc":"menu","filename":"docs/temp/ui/dropdown.zh.md","lastUpdated":1687013004000,"order":4,"redirect_from":["/zh/docs","/zh/docs/api","/zh/docs/api/ui"],"description":"下拉菜单。"};